<fieldset class="in-two-columns">
  <legend>{{ "MERCHANT.TITLE.WEB_LINKS" | translate }}:</legend>

  <ng-container [formGroup]="form">
    <ng-template
      let-control="control"
      let-title="title"
      let-icon="icon"
      #contactField
    >
      <mat-form-field>
        <app-easy-input
          [formControlName]="control"
          [label]="TITLE + title | translate"
          [svgPrefix]="'assets/pics/logos/' + icon"
        >
        </app-easy-input>
      </mat-form-field>
    </ng-template>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'facebook',
          icon: 'facebook.svg',
          title: 'FACEBOOK'
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'twitter',
          icon: 'twitter.svg',
          title: 'TWITTER'
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'instagram',
          icon: 'instagram.svg',
          title: 'INSTAGRAM'
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'linkedIn',
          icon: 'linkedin.svg',
          title: 'LINKEDIN'
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'youTube',
          icon: 'youtube.svg',
          title: 'YOUTUBE'
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'whatsApp',
          icon: 'whatsapp.svg',
          title: 'WHATSAPP'
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'viber',
          icon: 'viber.svg',
          title: 'VIBER'
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'skype',
          icon: 'skype.svg',
          title: 'SKYPE'
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        contactField;
        context: {
          control: 'web',
          icon: 'internet-explorer.svg',
          title: 'WEB'
        }
      "
    ></ng-container>
  </ng-container>
</fieldset>
